import { render, staticRenderFns } from "./ledger_statistics.vue?vue&type=template&id=5791aeb9&scoped=true"
import script from "./ledger_statistics.vue?vue&type=script&lang=ts"
export * from "./ledger_statistics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5791aeb9",
  null
  
)

export default component.exports